import React, { useEffect, useRef, useState } from 'react'
import isEqual from 'lodash/isEqual'

const Box = ({
    text,
    textValue = text,
    caption,
    styleText = '',
    styleCaption = 'gray bold small ',
    id = '',
    triggerAnimation = true,
    animationClass = 'text-pulsate',
}) => {
    const [isAnimating, setIsAnimating] = useState(false)
    const previousText = useRef(textValue)

    useEffect(() => {
        if (triggerAnimation && !isEqual(previousText.current, textValue)) {
            setIsAnimating(true)
            const animationTimeout = setTimeout(() => setIsAnimating(false), 8000)
            previousText.current = textValue
            return () => clearTimeout(animationTimeout)
        }
    }, [triggerAnimation, textValue]) // Restart animation when text or triggerAnimation changes

    return (
        <div className={'nav__balance menu-wrapper-column border margin-box'} id={id}>
            {text && (
                <span className={`nav__voted-amount wrap ${styleText} ${isAnimating ? animationClass : ''}`}>
                    {text}
                </span>
            )}
            <span className={styleCaption}>{caption}</span>
        </div>
    )
}

export default Box
